﻿/* global global, require */
/* eslint-disable no-unused-vars */
/* EFW plugin for Hub 3.0 */
window.$ = global.jQuery = require('jquery');
const event = require('jquery.event.gevent'),
    cookie = require('js-cookie'),
    iframeResize = require('../../common/js/iframeResizer'),
    iframeResizeContentWindow = require('../../common/js/iframeResizer.contentWindow'),
    bootstrap = require('bootstrap'),
    efw$local = require('../../common/js/efw.local.3.1'),
    efw$localdata = require('../../common/js/temp/efw.local.data'),
    efw$trackEvents = require('../../common/js/efw.trackEvents'),
    //efw$broadcast = require('../../common/js/efw.broadcast'),    // efw$broadcast obsolete
    efw$ping = require('../../common/js/efw.ping'),
    efw$dialog = require('../../common/js/efw.dialog.3.0'),
    efw$gpop = require('../../common/js/efw.gpop.3.0'),
    efw$links = require('../../common/js/efw.links'),
    efw$formvalid = require('../../common/js/efw.formvalid'),
    efw$logon = require('../../common/js/efw.logon.3.0'),
    hostInterface = require('../../common/js/hostInterface'),
    efw$logonUI = require('../../common/js/efw.logon.3.0.ui');
window.Cookie = cookie;